import { render } from "./TeamReportIntroPage.vue?vue&type=template&id=c50a4edc&scoped=true"
import script from "./TeamReportIntroPage.vue?vue&type=script&lang=js"
export * from "./TeamReportIntroPage.vue?vue&type=script&lang=js"

import "./TeamReportIntroPage.vue?vue&type=style&index=0&id=c50a4edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50a4edc"]])

export default __exports__